module.exports = __webpack_public_path__ + "static/media/beaker.0997d1cb.svg";